var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"congress-table-section"}},[_c('div',{staticClass:"inner"},[_c('h2',{staticClass:"text-center"},[_vm._v("Aktuální vzdělávací akce")]),_c('congress-table')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }